import {IPresentation} from '../../../incase-domain/presentation';
import {HANDLE_ELEMENTS_CLICKED} from './chalkBoardElements.actions.types';
import {GuestCredentials} from '../../../components/presentationView/parts/components/GuestModal';

export const FIND_PRESENTATION_BY_ID = 'FIND_PRESENTATION_BY_ID';
export const GET_PRESENTATION_IN_ROOM = 'GET_PRESENTATION_IN_ROOM';
export const UPDATE_PRESENTATION = 'UPDATE_PRESENTATION';
export const UPDATE_PRES_LOADING_STATE = 'UPDATE_PRES_LOADING_STATE';
export const UPDATE_FULL_PRESENTATION = 'UPDATE_FULL_PRESENTATION';
export const UPDATE_PRESENTATION_HAS_SLIDES = 'UPDATE_PRESENTATION_HAS_SLIDES';
export const UPDATE_PRESENTATION_RUNNING = 'UPDATE_PRESENTATION_RUNNING';
export const TOGGLE_DRAW_ENABLED = 'TOGGLE_DRAW_ENABLED';
export const UPDATE_DRAW_ENABLED = 'UPDATE_DRAW_ENABLED';
export const TOGGLE_REDRAW = 'TOGGLE_REDRAW';
export const UPDATE_PRESENTATION_STATUS = 'UPDATE_PRESENTATION_STATUS';

export interface IFindPresentationByIdAction {
    type: typeof FIND_PRESENTATION_BY_ID;
    payload: {id: string; credential: GuestCredentials | undefined; params: Record<string, string>};
}

export interface IGetPresentationInRoomAction {
    type: typeof GET_PRESENTATION_IN_ROOM;
    payload: {credential?: GuestCredentials; params: Record<string, string> | undefined; hash?: string; presenterCode?: string};
}
export interface IUpdatePresentationStatusAction {
    type: typeof UPDATE_PRESENTATION_STATUS;
    payload: {found: boolean; id: string};
}

export interface IUpdatePresentation {
    type: typeof UPDATE_PRESENTATION;
    payload: IPresentation;
}
export interface IUpdatePresLoadingState {
    type: typeof UPDATE_PRES_LOADING_STATE;
    payload: number;
}

export interface IUpdateFullPresentation {
    type: typeof UPDATE_FULL_PRESENTATION;
    payload: IPresentation;
}

export interface IUpdatePresentationHasSlidesAction {
    type: typeof UPDATE_PRESENTATION_HAS_SLIDES;
    payload: boolean;
}

export interface IHandleElementsClicked {
    type: typeof HANDLE_ELEMENTS_CLICKED;
    payload: {
        clearBeforeClick: boolean;
        clickedElementIds: string[];
    };
}

export interface IToggleDrawEnabledAction {
    type: typeof TOGGLE_DRAW_ENABLED;
}

export interface IToggleRedrawAction {
    type: typeof TOGGLE_REDRAW;
}

export interface IUpdateDrawEnabledAction {
    type: typeof UPDATE_DRAW_ENABLED;
    payload: boolean;
}
